export const BLOCK_WS = 'BLOCK_WS';
export const BLOCK_WS_SUCCESS = 'BLOCK_WS_SUCCESS';
export const BLOCK_WS_ERROR = 'BLOCK_WS_ERROR';
